import { Navigate } from 'react-router-dom'
import AdminLayout from '../components/Layouts/AdminLayout'
import HeaderContainer from '../containers/Header/Header.container'
import SidebarContainer from '../containers/Sidebar/Sidebar.container'
import SupportTicketsContainer from '../containers/Support/SupportTickets.container'
import { useAcl } from '../containers/AccessControlList/acl.hook'
import routes from '../config/settings/routes'
import { PageStack } from '../components/Layouts/PagePanel'

const SupportPage = () => {
  const { isAdmin } = useAcl()

  if (!isAdmin) {
    return <Navigate to={routes.help} replace />
  }

  return (
    <AdminLayout
      header={<HeaderContainer />}
      sidebar={<SidebarContainer />}
      title="Tickets"
      description="Bandeja de soporte y feedback de usuarios."
    >
      <PageStack $fullWidth>
        <SupportTicketsContainer />
      </PageStack>
    </AdminLayout>
  )
}

export default SupportPage
